import { render } from "./TablaEmpleados.vue?vue&type=template&id=d606d830&scoped=true"
import script from "./TablaEmpleados.vue?vue&type=script&lang=js"
export * from "./TablaEmpleados.vue?vue&type=script&lang=js"

import "./TablaEmpleados.vue?vue&type=style&index=0&id=d606d830&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d606d830"]])

export default __exports__